import { Portal } from 'react-native-paper'
import { StyleSheet } from 'react-native-unistyles'

import DocumentEdit from '@/components/fosters/documents/DocumentEdit'
import UniModal from '@/components/unistyles/UniModal'

interface Props {
  documentId: string
  open: boolean
  onClose: () => void
}

const DocumentEditModal = ({ documentId, open, onClose }: Props) => {
  return (
    <Portal>
      <UniModal
        contentContainerStyle={styles.root}
        onDismiss={onClose}
        visible={open}
      >
        <DocumentEdit documentId={documentId} onSubmit={onClose} />
      </UniModal>
    </Portal>
  )
}

const styles = StyleSheet.create((theme) => {
  return {
    root: {
      alignSelf: 'center',
      backgroundColor: theme.colors.background,
      borderRadius: theme.tokens.containerBorderRadius,
      height: '90%',
      padding: theme.tokens.spacing[4],
      width: '90%',
    },
  }
})

export default DocumentEditModal
